import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-recruiter-trusted-companies',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-trusted-companies.component.html',
  styleUrls: ['./recruiter-trusted-companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterTrustedCompaniesComponent {}
